import { render, staticRenderFns } from "./claimApply.vue?vue&type=template&id=78b5972c&scoped=true&"
import script from "./claimApply.vue?vue&type=script&lang=js&"
export * from "./claimApply.vue?vue&type=script&lang=js&"
import style0 from "./claimApply.vue?vue&type=style&index=0&id=78b5972c&lang=scss&scoped=true&"
import style1 from "./claimApply.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78b5972c",
  null
  
)

export default component.exports